module.exports = __webpack_public_path__ + "assets/img/icon_qrcode1.b61dadd4.png";